import { eCDV3ItemTypes } from '../../../ui-toolkit/enums/eCDV3ItemTypes';
import { ICDV3ViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

const filterByType =
  (...types: eCDV3ItemTypes[]) =>
  (item: ICDV3ViewItem) =>
    types.indexOf(item.type) >= 0;

export default filterByType;
